import { EnvironmentInjector, inject } from '@angular/core';

import { LazyComponentDetails } from '@core/shared/util';
import { ComponentPluginComponent } from '@mp/shared/component-plugins/util';
import { LoginContextService } from '@mpk/shared/data-access';
import type { ClinicSupplierDetailsTabPlugin, ClinicSupplierDetailsTabPluginInput } from '@mpsm/shared/util';

import { SupplierPurchaseRequisitionSettingsPermissions } from '../permissions';

export function createClinicSupplierPurchaseRequisitionsTabPlugin(): ClinicSupplierDetailsTabPlugin {
  const loginContextService = inject(LoginContextService);

  return {
    label: 'Anforderungen',
    isEnabled: loginContextService.permission(
      SupplierPurchaseRequisitionSettingsPermissions.ViewSupplierPurchaseRequisitionSettings,
    ),
    async getComponentDetails(
      parentInjector: EnvironmentInjector,
    ): Promise<LazyComponentDetails<ComponentPluginComponent<ClinicSupplierDetailsTabPluginInput>>> {
      const { ClinicSupplierPurchaseRequisitionSettingsEditComponent } = await import('../pages');

      return {
        component: ClinicSupplierPurchaseRequisitionSettingsEditComponent,
        environmentInjector: parentInjector,
      };
    },
  };
}
